<template>
	<div class="container mt-5">

		<h1 class="title-primary">Авторизация на сайте</h1>

		<div class="row">
			<div class="col-md-8 col-lg-5 col-xl-4">

				<app-form api="user/register">
					<div class="mb-4">
						<label for="sign-up-input-email">Email</label>
						<input id="sign-up-input-email" type="email" v-model="email" class="form-control">

						<ValidateErrors :errors="v$.email.$errors"/>
					</div>

					<div class="mb-4">
						<label for="sign-up-input-pass">Пароль</label>
						<div class="d-flex">
							<input id="sign-up-input-pass" :type="isPassVisible ? 'text' : 'password'" v-model="password" class="form-control">
							<button type="button" class="btn ms-1 text-end pass-visible-toggle" @click="changePassVisible">
								{{isPassVisible ? 'hide pass' : 'show pass'}}
							</button>
						</div>
						<ValidateErrors :errors="v$.password.$errors"/>
					</div>

					<div>
						<button type="button" class="btn btn-primary" @click="login">
							<span class="button-spinner" :class="{
								'button-spinner_active': isLoginWait
							}" data-text="Войти на сайт"/>
						</button>
					</div>

					<hr class="my-4" style="opacity: 0.1;">

					<div>
						<p>Нет профиля? <router-link :to="{name: 'sign-up'}">Регистрация</router-link></p>
					</div>
				</app-form>
			</div>
		</div>


	</div>
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
import ValidateErrors from '@/components/validate-errors'
import AppForm from '@/components/app-form'

export default {
	setup () {
		return {
			v$: useVuelidate()
		}
	},
	components: {
		'app-form': AppForm,
		ValidateErrors
	},
	data() {
		return {
			email: '',
			password: '',
			isPassVisible: false,
			isLoginWait: false,

			// server side validate errors
			vuelidateExternalResults: {
				email: [],
			},
		}
	},
	methods: {
		changePassVisible() {
			this.isPassVisible = !this.isPassVisible;
		},

		async login() {
			// clear extra error
			this.vuelidateExternalResults.email = [];

			const valid = await this.v$.$validate();

			if (!valid || this.isLoginWait) return false;

			// start waiting anim
			this.isLoginWait = true;

			const request = new URLSearchParams();
			request.append('login', this.email);
			request.append('password', this.password);

			this.axios.post(this.appconf.apiHost + 'user/auth', request)
				.then(response => {
					const data = response.data;
					console.log(data);

					if (data.error && typeof data.error === 'object' && Object.keys(data.error).length) {
						this.vuelidateExternalResults.email = Object.values(data.error);
					} else if (data.token) {

						// add user data to storage
						localStorage.setItem('user', JSON.stringify({
							id: data.id,
							token: data.token
						}));

						// reload page. самый простой и быстрый способ
						window.location = '/';

					}
				})
				.catch(error => {
					this.vuelidateExternalResults.email = [error.toString()];
				})
				.then(() => {
					this.isLoginWait = false;
				});
		}
	},
	validations() {
		return {
			email: { required, email },
			password: { required }
		}
	}
}
</script>